import {PlayerReduxState} from "../types";

export default function getLevel(state: PlayerReduxState): number {
  return state.level;
}
